module.exports = __webpack_public_path__ + "img/collect-active.f31f0897.png";